<div class="cipo" [class.results-height]="haveSearchedText()" fxLayout="column">
    <cipo-search-filter (filterChanges)="onFilterChanges()" />

    @if (!isLoading() && !haveItems()) {
        <div fxLayout="row" class="m-x-md">
            <cipo-not-found icon="search" [title]="'SEARCH_AI.NO_RESULTS_FOUND'" class="cipo--width--full" />
        </div>
    } @else {
        <div class="results-container" fxLayout="column">
            <div fxFlex="grow">
                <cdk-virtual-scroll-viewport
                    itemSize="104"
                    class="cipo--height--full"
                    [class.scroll-viewport-overflow]="recordsCount() > pageSize()"
                    (scrolledIndexChange)="onScroll()">
                    <div
                        *cdkVirtualFor="let result of items(); trackBy: virtualTrackBy"
                        fxLayout="column"
                        fxLayoutAlign="space-between"
                        fxLayoutGap="12px">
                        <cipo-search-result-card [searchResult]="result" (documentOpened)="documentOpened.emit()" />
                    </div>
                    @if (haveSearchedText() && isLoading()) {
                        @for (item of MAX_SKELETONS(); track $index) {
                            <div fxLayout="column">
                                <div fxLayout="row" fxLayoutAlign="start center" class="skeleton-item">
                                    <div class="skeleton-circle"></div>
                                    <div class="skeleton-text">
                                        <div class="skeleton-line short"></div>
                                        <div class="skeleton-line long"></div>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
    }
    @if (!isInfiniteScroll() && haveSearchedText()) {
        <mat-paginator
            class="compact"
            [class.hidden]="!recordsCount()"
            [length]="recordsCount()"
            [pageSize]="pageSize()"
            [pageSizeOptions]="pageSizeOptions"
            (page)="loadPagedItems($event)" />
    }
    @if (
        haveItems() &&
        ((!isLoading() && !isInfiniteScroll() && recordsCount() < pageSize()) || (isInfiniteScroll() && nextPage > 1))
    ) {
        <div class="results-count">{{ "SEARCH_AI.FOUND_RESULTS" | translate: { count: recordsCount() } }}</div>
    }
</div>
